import clsx from 'clsx';

import { Title } from '@components/Title';

import { FeatureListItem } from './FeatureListItem';

interface FeatureListProps {
  variant: 'primary' | 'secondary';
  size?: 'large' | 'normal' | 'small';
  data?: FeatureList;
  elevated?: boolean;
}

export const FeatureList: React.FC<FeatureListProps> = ({
  variant,
  size = 'normal',
  data,
  elevated,
}) => (
  <div className="feature-list flex flex-col gap-12">
    <Title variant="start" data={data?.title} />

    <div
      className={clsx(
        'grid grid-cols-1 flex-wrap items-stretch justify-center gap-8 md:grid-cols-2 md:justify-start lg:flex',
        !elevated && 'gap-y-12',
      )}
    >
      {data?.items?.map((item, index) => (
        <FeatureListItem
          key={index}
          data={item}
          variant={variant}
          size={size}
          linkLabel={data?.linkLabel}
          elevated={elevated}
        />
      ))}
    </div>
  </div>
);
